import React, { useContext, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { blue20, blue50, blue90 } from '../../../constants/colors';
import { versionUpdateMessages } from '../../../constants/messages';
import { globalHeaderHeight } from '../../../constants/location';
import { PROXY_BANNER_HEIGHT } from '../../../constants/labels';
import { ProxyLoginContext } from '../../../contexts/ProxyLoginContext';
import useVersionCheck from '../../../hooks/useVersionCheck';

const NOTIFICATION_TOP_GAP_PX = 16;

const styles = {
  alert: {
    '& .MuiAlert-icon': {
      color: blue50,
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiAlert-message': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiAlert-action': {
      alignItems: 'center',
      paddingTop: 0,
    },
    backgroundColor: blue20,
    border: `1px solid ${blue50}`,
    color: blue90,
    fontSize: '14px',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
  reloadButton: {
    color: blue90,
    fontWeight: 'bold',
    borderColor: blue50,
    '&:hover': {
      borderColor: blue90,
      backgroundColor: 'rgba(10, 126, 191, 0.08)',
    },
    marginRight: '4px',
  },
  closeButton: {
    color: blue90,
  },
};

const VersionUpdateSnackbar: React.FC = () => {
  const isNewVersionAvailable = useVersionCheck();
  const [isDismissed, setIsDismissed] = useState<boolean>(false);
  const { isProxyLogin } = useContext(ProxyLoginContext);

  const open = isNewVersionAvailable && !isDismissed;

  const topOffset = isProxyLogin
    ? `calc(${globalHeaderHeight} + ${PROXY_BANNER_HEIGHT}px + ${NOTIFICATION_TOP_GAP_PX}px)`
    : `calc(${globalHeaderHeight} + ${NOTIFICATION_TOP_GAP_PX}px)`;

  const handleReload = (): void => {
    window.location.reload();
  };

  const handleClose = (): void => {
    setIsDismissed(true);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={null}
      sx={{ top: `${topOffset} !important` }}
    >
      <MuiAlert
        severity="info"
        sx={styles.alert}
        action={
          <>
            <Button size="small" variant="outlined" onClick={handleReload} sx={styles.reloadButton}>
              {versionUpdateMessages.reloadButton}
            </Button>
            <IconButton
              size="small"
              aria-label="close"
              onClick={handleClose}
              sx={styles.closeButton}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      >
        {versionUpdateMessages.newVersionAvailable}
      </MuiAlert>
    </Snackbar>
  );
};

export default VersionUpdateSnackbar;
